
import React from "react";
import styles from "./Actualites.module.css";
import { ActualitesTypes } from "@/types/displayData/ActualitesTypes";

const ActualitesComponent: React.FC<ActualitesTypes> = ({ title, subtitle, description, news }) => {
  return (
    <section className={styles.actualitesContainer}>
      <h2 className={styles.actualitesTitle}>{title}</h2>
      <h3 className={styles.actualitesSubtitle}>{subtitle}</h3>
      <p className={styles.actualitesDescription}>{description}</p>

      <div className={styles.newsGrid}>
        {news.map((item, index) => (
          <div key={index} className={styles.newsCard}>
            <img src={item.image} alt={item.title} className={styles.newsImage} />
            <div className={styles.newsContent}>
              <h4 className={styles.newsTitle}>{item.title}</h4>
              <p className={styles.newsDescription}>{item.description}</p>
            </div>
            <a href={item.link} className={styles.newsLink}>En savoir plus</a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ActualitesComponent;
